export default __webpack_public_path__ + "static/media/bridgegap.96f25ff0.png";